import React, { useContext } from 'react';
import './Language.scss';
import { LanguageContext } from '../../../context/language-context';

const Language = (props) => {
  const lng = useContext(LanguageContext);

  return (
    <ul className={`language ${props.className}`}>
      <li
        className={lng.language === 'en' ? 'active' : undefined}
        onClick={() => lng.change('en')}
      >
        EN
      </li>
      <span>|</span>
      <li
        className={lng.language === 'jp' ? 'active' : undefined}
        onClick={() => lng.change('jp')}
      >
        JP
      </li>
    </ul>
  );
};

export default Language;
